import { Link, Menu, MenuButton, MenuItem, MenuList, Portal, Text } from '@chakra-ui/react';
import NextLink from 'next/link';

import { RegistryPackage } from '@/graphql/upbound-graphql';
import ChevronIcon from '@/icons/ChevronIcon';
import { ROUTE_PACKAGE_DETAILS } from '@/utils/constants/routes';

const PackageVersionMenu: React.FC<{ data: RegistryPackage }> = ({ data }) => {
  if (!data || !data.versions || data.versions.length < 2) {
    return null;
  }

  const [firstVersion] = data.versions;
  const selectedVersion = data.version || firstVersion;

  return (
    <Menu
      placement="bottom-end"
      gutter={0}
      matchWidth
      isLazy
      preventOverflow={false}
      flip={false}
      eventListeners={{ resize: true, scroll: false }}
    >
      <MenuButton width="100%" className="listing-version-dropdown">
        <Text as="span">{selectedVersion}</Text>
        <ChevronIcon direction="down" size="sm" />
      </MenuButton>
      <Portal>
        <MenuList width="100%">
          {data.versions.map(version => (
            <NextLink
              key={version}
              href={{
                ...ROUTE_PACKAGE_DETAILS,
                query: {
                  packageType: data.packageType.toLowerCase() + 's',
                  packageAccount: data.account,
                  packageName: data.name,
                  packageVersion: version,
                },
              }}
              passHref={true}
            >
              <MenuItem as={Link} width="100%">
                {version}
              </MenuItem>
            </NextLink>
          ))}
        </MenuList>
      </Portal>
    </Menu>
  );
};

export default PackageVersionMenu;
